export default {
    setState(state, payload) {
        // Log the current state and payload
        console.log('Mutation setState called with:', { currentState: state, payload });
        
        // Create a new state object by spreading the current state and then the payload
        // This ensures we don't lose any existing state properties
        const newState = { ...state, ...payload };
        
        // Log the updated state
        console.log('State after update:', newState);
        
        return newState;
    }
};